import { Head } from "@inertiajs/react"
import { Container, Heading, Section } from "@radix-ui/themes"
import ManagershipsTable from "@/shared/admin/ManagershipsTable"
import { UserWithManagerships, ManageableForAdmin } from "@/types/shared"

interface Props {
  users: UserWithManagerships[]
  all_clubs: ManageableForAdmin[]
}

export default function AdminClubManagersIndex({ users, all_clubs }: Props) {
  return (
    <div className="flex">
      <Head title="Club Managers - Admin" />
      <div className="grow">
        <Section>
          <Container size="4">
            <Heading size="7" mb="6">
              Club Manager Assignments
            </Heading>
            <ManagershipsTable
              users={users}
              assignable={all_clubs}
              endpoint="/admin/club_managers"
              paramKey="club_id"
              placeholder="Select a club..."
              emptyMessage="No clubs assigned"
            />
          </Container>
        </Section>
      </div>
    </div>
  )
}
